import React, { useEffect, useState, useRef } from "react";
import { useUsermaven } from "@usermaven/react";

interface JEREMYProps {
  onExit: (to: string) => void;
}

interface AXISXY {
  x: {
    pos: number;
    value: number;
  };
  y: {
    pos: number;
    value: number;
  };
}

const JEREMY: React.FC<JEREMYProps> = ({ onExit }) => {
  const { track } = useUsermaven();

  const video = useRef<HTMLVideoElement>(null);

  const CLL14 = useRef<HTMLDivElement>(null);
  const GLOW = useRef<HTMLDivElement>(null);
  const ESMO = useRef<HTMLDivElement>(null);

  const [timeStamp, setTimeStamp] = useState<number | null>(null);
  const [animType, setanimType] = useState<string>("");

  const setAxis = ({ name, position }: { name: 'CLL14' | 'GLOW' | 'ESMO'; position: AXISXY }): void => {
    const refMap = {
      CLL14,
      GLOW,
      ESMO,
    };

    const element = refMap[name]?.current;

    if (!element) return;

    element.style.top = `${position.y.pos}%`;
    element.style.left = `${position.x.pos}%`;
    element.style.width = `${position.x.value}px`;
    element.style.height = `${position.y.value}px`;
  }

  switch (animType) {
    case "INTRO":
      setAxis({ name: "CLL14", position: { x: { pos: 29, value: 440 }, y: { pos: 43, value: 200 } } });
      setAxis({ name: "GLOW", position: { x: { pos: 54, value: 380 }, y: { pos: 52.5, value: 100 } } });
      setAxis({ name: "ESMO", position: { x: { pos: 30, value: 850 }, y: { pos: 63.5, value: 95 } } });
      break;
    case "TIMELINE":
      setAxis({ name: "CLL14", position: { x: { pos: 60.5, value: 155 }, y: { pos: 6, value: 55 } } });
      setAxis({ name: "GLOW", position: { x: { pos: 69, value: 155 }, y: { pos: 6, value: 55 } } });
      setAxis({ name: "ESMO", position: { x: { pos: 77.5, value: 185 }, y: { pos: 6, value: 55 } } });
      break;
    default:
      break;
  }


  useEffect(() => {
    track("Case Jeremy");
  }, []);

  useEffect(() => {
    console.log('timeStamp', timeStamp);

    if (timeStamp === null) return;

    if(timeStamp >= 5 && timeStamp <= 15)
      setanimType("INTRO");
    else if (timeStamp > 15)
      setanimType("TIMELINE");
    else setanimType("");

  }, [timeStamp])
  
  const transitionTo = (to: number) => {
    if (video.current) {
      return video.current.currentTime = to;
    }
  }

  const transitionBack = () => {
    onExit("/menu");
  };

  return (
    <div id="profile_jeremy" className="h-screen w-screen">
      <div
        className="w-40 h-40 absolute left-0 top-0 z-10"
        onClick={() => transitionBack()}
      ></div>

      <div ref={CLL14} onClick={() => transitionTo(17.75)} className={`fixed bg-red-0 opacity-0 z-20`}></div>
      <div ref={GLOW} onClick={() => transitionTo(38)} className={`fixed bg-blue-0 opacity-0 z-20`}></div>
      <div ref={ESMO} onClick={() => transitionTo(56.6)} className={`fixed bg-green-0 opacity-0 z-20`}></div>

      <video
        className="h-full w-full object-cover"
        autoPlay
        playsInline
        muted
        // controls
        onEnded={() => transitionBack()}
        onTimeUpdate={(event: any) => {
          setTimeStamp(Math.round(event.target.currentTime));
        }}
        ref={video}
      >
        <source src="../assets/profiles/jeremy_content.mp4?v=2" />
      </video>
    </div>
  );
};

export default JEREMY;
